import React from "react";

interface Props {
    children: React.ReactNode;
}

export const EmptyContent = ({ children }: Props) => (
    <div className="empty-content">{children}</div>
);
